"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackGround = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var clsx_1 = __importDefault(require("clsx"));
var O = __importStar(require("fp-ts/Option"));
var Option_1 = require("fp-ts/Option");
var function_1 = require("fp-ts/function");
require("./backGround.css");
var BackGround = function (_a) {
    var color = _a.color, innerWrapperCustomStyle = _a.innerWrapperCustomStyle, footerAction = _a.footerAction, style = _a.style, children = _a.children, _b = _a.hover, hover = _b === void 0 ? false : _b, _c = _a.padding, padding = _c === void 0 ? 'std' : _c, _d = _a.radius, radius = _d === void 0 ? 'none' : _d, _e = _a.shadow, shadow = _e === void 0 ? 'none' : _e, _f = _a.halfOpacity, halfOpacity = _f === void 0 ? false : _f, _g = _a.border, border = _g === void 0 ? { type: 'none' } : _g;
    var renderFooter = function () {
        return (0, function_1.pipe)(O.fromNullable(footerAction), (0, Option_1.map)(function (f) { return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "bg-footer", onClick: f.onClick }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ className: "bg-footer-label" }, { children: f.label })) }))); }), O.toNullable);
    };
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, clsx_1.default)('bg-color', "bg-radius-".concat(radius), "bg-shadow-".concat(shadow), "bg-border-".concat(border.type), "bg-border-style-".concat(border.type !== 'none' ? border.style : 'none'), { halfOpacity: halfOpacity }, "".concat(hover ? 'bg-hover' : '')), css: (0, react_1.css)(style) }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: (0, clsx_1.default)('bg-body', "bg-color-".concat(color), "bg-padding-".concat(padding), "bg-radius-".concat(radius), (0, react_1.css)(innerWrapperCustomStyle).name) }, { children: children })), renderFooter()] })));
};
exports.BackGround = BackGround;
//# sourceMappingURL=BackGround.js.map